import { observer } from 'mobx-react-lite';

import { Card } from '@components/card';
import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { useStore } from 'models/Provider';

export const NationalRegistryInformation = observer(({ info }) => {
  const { t } = useStore();
  return (
    <Card space={4} variant="default">
      <Stack space={0} orientation="horizontal" wrap>
        <Stack style={{ overflow: 'hidden', flexGrow: 1 }}>
          {['name', 'ssn', 'age', 'ageYearEnd'].map((column) => (
            <Stack orientation="horizontal" space={2} align="center" key={column}>
              <Text
                font="semibold14"
                color="purple80"
                text={t('application.details.ssnregistry.' + column) + ':'}
              />
              {info[column] ? (
                <Text font="regular14" color="purple80" ellipsis text={info[column]} />
              ) : (
                <Text
                  color="purple40"
                  font="regular14"
                  text={t('application.details.ssnregistry.no_details')}
                />
              )}
            </Stack>
          ))}
        </Stack>
        <Stack style={{ overflow: 'hidden', flexGrow: 1 }}>
          {['street', 'city', 'postalCode'].map((column) => (
            <Stack orientation="horizontal" space={2} align="center" key={column}>
              <Text
                font="semibold14"
                color="purple80"
                text={t('application.details.ssnregistry.' + column) + ':'}
              />
              {info[column] ? (
                <Text font="regular14" color="purple80" ellipsis text={info[column]} />
              ) : (
                <Text
                  color="purple40"
                  font="regular14"
                  text={t('application.details.ssnregistry.no_details')}
                />
              )}
            </Stack>
          ))}
          <Stack orientation="horizontal" space={2} align="center">
            <Text
              font="semibold14"
              color="purple80"
              text={t('application.details.ssnregistry.gender') + ':'}
            />
            {info.gender ? (
              <Text
                font="regular14"
                color="purple80"
                ellipsis
                text={t(`ssnregistry.gender.${info.gender}`)}
              />
            ) : (
              <Text
                color="purple40"
                font="regular14"
                text={t('application.details.ssnregistry.no_details')}
              />
            )}
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
});
